import { Button, Typography } from "@suraasa/placebo-ui"
import { Theme } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import OverlayWrapper from "features/Cpat/Assessments/Proctoring/OverlayWrapper"
import { Expand } from "iconoir-react"
import { createUseStyles } from "react-jss"

type Props = {
  onContinue: () => void
}

const useStyles = createUseStyles((theme: Theme) => ({
  color: {
    color: "#FFFFFF",
  },
  box: {
    backgroundColor: "#EFEFF7",
    borderRadius: "14px",
  },
  text: {
    width: "65%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}))

const FullscreenOverlay = ({ onContinue }: Props) => {
  const classes = useStyles()

  return (
    <>
      <OverlayWrapper backgroundImg="url('/src/features/Cpat/Assessments/Attempt/Proctoring/assets/attemptAssessment.png')">
        <div className="flex flex-col items-center justify-center gap-8 p-2 sm:p-4">
          <div>
            <div
              className={clsx(
                classes.box,
                "xs:p-6 flex justify-center p-4 sm:p-8"
              )}
            >
              <Expand height={75} width={75} />
            </div>
          </div>
          <Typography
            variant="title1"
            className={clsx("text-center", classes.color, classes.text)}
          >
            You need to be in fullscreen mode to attempt the assessment
          </Typography>
          <Button onClick={onContinue} color="black" size="lg">
            Click here to continue assessment
          </Button>
        </div>
      </OverlayWrapper>
    </>
  )
}

export default FullscreenOverlay
